<template>
    <nav class="bg-white shadow-lg">
        <div class="max-w-7xl mx-auto px-4">
            <div class="flex justify-between items-center h-16">
                <!-- Logo -->
                <NuxtLink to="/">
                    <AppLogo />
                </NuxtLink>

                <!-- Navigation Links -->
                <div class="hidden md:flex space-x-8 items-center">
                    <!-- <NuxtLink to="/" class="text-gray-700 hover:text-cost-red">Home</NuxtLink> -->
                    <!-- <NuxtLink to="/user/dashboard" class="text-gray-700 hover:text-cost-red">Dashboard</NuxtLink> -->
                    <NuxtLink to="/auth/signup" class="bg-cost-red text-white px-4 py-2 rounded-lg hover:bg-red-600">
                        Sign Up
                    </NuxtLink>
                    <!-- <NuxtLink to="/auth/signin" class="text-cost-blue hover:text-blue-600">
                        Sign In
                    </NuxtLink> -->
                </div>
            </div>
        </div>
    </nav>
</template>